import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';

interface InformedConsentFilePickerProps {
    /** HTML accept attribute, e.g. ".csv" or ".pdf" */
    accept: string;
    buttonLabel?: string;
    onSelect(file: File): void;
    validate(file: File): boolean;
}

export default function InformedConsentFilePicker({
    accept,
    buttonLabel = 'Select File',
    onSelect,
    validate,
}: InformedConsentFilePickerProps) {
    const fileUploadInput = useRef<HTMLInputElement>(null);

    const openPicker = () => {
        fileUploadInput.current?.click();
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files?.length) {
            return;
        }

        const file = files[0];
        if (!validate(file)) {
            e.target.value = '';
            return;
        }

        onSelect(file);
        e.target.value = '';
    };

    return (
        <div className="mt-3">
            <input type="file" accept={accept} className="d-none" onChange={handleFileChange} ref={fileUploadInput} />
            <Button className="select-file-btn" type="button" onClick={openPicker}>
                {buttonLabel}
            </Button>
        </div>
    );
}
